
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34501',
  depVersions: {
  "documents-public-ui": "static-1.34501",
  "atom": "static-1.5070",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2496",
  "client-types": "static-1.466",
  "cssUtils": "static-1.792",
  "customer-data-filters-ui": "static-1.39755",
  "customer-data-objects": "static-1.7668",
  "customer-data-property-utils": "static-1.8088",
  "documents-lib": "static-1.34506",
  "emoji-mart": "static-3.4",
  "FormsCommonComponents": "static-1.85836",
  "FormUrlGenerator": "static-2.4716",
  "foundations-theming-specialty": "static-1.2131",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5592",
  "hs-test-utils": "static-1.8012",
  "hub-http": "static-1.6221",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11471",
  "I18n": "static-7.1626",
  "jasmine-immutable": "static-1.3020",
  "jasmine-runner": "static-1.6464",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7155",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5399",
  "quartz": "static-1.7031",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16671",
  "react-utils": "static-2.5341",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8170",
  "reference-resolvers-lite": "static-1.8093",
  "reporting-data": "static-1.67528",
  "reporting-reports": "static-1.67206",
  "reporting-snowflake": "static-1.56146",
  "reporting-testing-lib": "static-1.9461",
  "reporting-visualizations": "static-1.59604",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8941",
  "sanitize": "static-1.4475",
  "sanitize-text": "static-1.8141",
  "self-service-api": "static-1.10247",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1747",
  "signup-constants": "static-1.18831",
  "signup-ui-url-generator": "static-2.8045",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4760",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4762",
  "ui-addon-form-validation": "static-1.10990",
  "ui-asset-management-lib": "static-1.11027",
  "ui-images": "static-2.1154",
  "usage-tracker": "static-1.7343",
  "usage-tracker-container": "static-1.7333",
  "usage-tracker-core": "static-1.7193",
  "viral-links-lib": "static-1.7059",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9668",
  "flux-actions": "static-1.337",
  "foundations-components": "static-1.7931",
  "HubStyle": "static-2.11778",
  "icons": "static-2.646",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.397",
  "quartz-config": "static-1.809",
  "quartz-core": "static-1.6250",
  "quick-fetch": "static-1.3914",
  "raven": "static-3.5907",
  "react-select-plus": "static-1.105",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-ui-components": "static-2.64799",
  "rpc-client-utils": "static-1.4650",
  "transmute": "static-2.85",
  "ui-addon-i18n": "static-1.11149",
  "ui-addon-upgrades": "static-9.17988",
  "UIComponents": "static-3.8417",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3397",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3308",
  "quartz-webpack": "static-1.3255",
  "foundations-assets": "static-1.4864",
  "foundations-theming": "static-1.4415",
  "hub-http-shared-msw-handlers": "static-1.9954",
  "hubspotter-http": "static-1.4649",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.218",
  "conversations-skeleton-state": "static-1.7245",
  "crm-message-bus": "static-1.42978",
  "customer-data-filters-ui-msw-helpers": "static-1.22190",
  "customer-data-objects-ui-components": "static-1.13025",
  "customer-data-reference-ui-components": "static-1.13162",
  "customer-data-ui-utilities": "static-1.9825",
  "framework-builder-read-service-client": "static-1.4002",
  "framework-data-schema-quick-fetch": "static-1.6788",
  "framework-data-schema-resolvers": "static-1.6883",
  "inbound-db-meta-service-client": "static-1.3582",
  "inbound-db-properties-service-client": "static-1.3843",
  "multi-account-reference-resolvers": "static-1.979",
  "onboarding-tours": "static-1.16595",
  "reporting-datasets-permissions-lib": "static-1.13671",
  "ui-addon-teams": "static-1.21547",
  "quartz-auth": "static-1.706",
  "ui-business-units-lib": "static-1.9052",
  "usage-tracker-session-replay": "static-1.5029",
  "ai-components-ui-library": "static-1.8972",
  "ContentUtils": "static-1.68354",
  "customer-data-properties": "static-1.51536",
  "forms-ai-lib": "static-1.4317",
  "forms-utils-lib": "static-1.12579",
  "foundations-components-test-utils": "static-1.5414",
  "react-dnd-compat": "static-1.4614",
  "react-tinymce": "static-1.55233",
  "tinymce-config": "static-2.54359",
  "ui-gdpr-components": "static-1.10347",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3400",
  "HeadJS": "static-2.761",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3123",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.78",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4326",
  "csstype": "static-1.50",
  "quartz-head": "static-1.696",
  "web-vitals": "static-1.5",
  "batch-promise": "static-1.1539",
  "external-options-client-types": "static-1.4155",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.706",
  "frontend-preferences-client": "static-1.7927",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3696",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25368",
  "hubspot-apollo-client": "static-1.4877",
  "foundations-components-legacy": "static-1.956",
  "merchandise-lib": "static-1.263",
  "quartz-routing": "static-1.461",
  "hs-story-utils": "static-1.9424",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.225",
  "timezone-utils": "static-2.5242",
  "bend-plugin-foundations-components": "static-1.4200",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.24",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1932",
  "ui-fonts": "static-1.733",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.835",
  "mobile-manifest-mixins": "static-1.535",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.706",
  "quartz-tracking": "static-1.410",
  "reporting-action-components": "static-1.41298",
  "reporting-plugins": "static-1.10321",
  "bend-plugin-chirp-manifest": "static-1.60",
  "chirp-fetch": "static-1.1886",
  "purchase-motions-components": "static-1.5894",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4077",
  "bender-build-tools": "static-1.3199",
  "bend-plugin-foundations-theming": "static-1.2898",
  "stylex": "static-1.33",
  "hs-resources": "static-1.148",
  "pulse": "static-1.571",
  "restore-request-side-panel-lib": "static-1.885",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3794",
  "crm-pipelines-api-client-types": "static-1.4135",
  "fdsr-migration-layer": "static-1.2",
  "multi-currency-client-types": "static-1.3688",
  "getting-started-shared-tasks": "static-1.18468",
  "growth-data-modal": "static-1.5427",
  "growth-onboarding-confetti": "static-1.3065",
  "growth-onboarding-next-action-utils": "static-1.1906",
  "navigation-components": "static-1.18028",
  "onboarding-tours-client": "static-1.4809",
  "onboarding-tours-utils": "static-1.661",
  "ui-shepherd-react": "static-3.10162",
  "ui-shepherd-tracker": "static-1.7543",
  "ui-universal-auth": "static-1.8975",
  "user-context": "static-1.5102",
  "hubspotter-http-shared-msw-handlers": "static-1.9952",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21282",
  "copilot-toolkit": "static-1.11128",
  "cms-field-types": "static-1.4809",
  "content-icons-ui": "static-1.2227",
  "integrations-lib": "static-1.16113",
  "calling-global-api": "static-1.64500",
  "calling-internal-common": "static-1.31301",
  "calling-lifecycle-internal": "static-1.65882",
  "calling-lifecycle-messages": "static-1.58176",
  "commerce-products-lib": "static-1.9541",
  "crm-links": "static-1.6290",
  "customer-data-properties-shared-msw-handlers": "static-1.9281",
  "file-manager-components": "static-1.23621",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4220",
  "meetings-icalendar-utils-lib": "static-1.629",
  "object-builder-ui-client": "static-1.48732",
  "pipeline-validation-client-types": "static-1.3962",
  "property-value-citations": "static-1.2150",
  "smart-property-lib": "static-1.6987",
  "tiered-pricing": "static-1.1212",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9056",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19832",
  "tinymce-themes": "static-1.56329",
  "data-token-picker": "static-1.16408",
  "hub-http-contrib": "static-1.3041",
  "interframe": "static-3.4758",
  "tinymce-data": "static-1.40444",
  "tinymce-plugins": "static-1.57473",
  "ui-addon-sales-email": "static-1.5210",
  "onboarding-scopes": "static-1.6460",
  "ui-addon-opt": "static-4.8365",
  "apollo-link-hub-http": "static-2.4648",
  "hubspot-apollo-cache": "static-1.336",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.171",
  "content-assistance-lib": "static-1.7750",
  "dashboard-lib": "static-1.81522",
  "ExportDialog": "static-6.10388",
  "hubspot-prosemirror": "static-1.18227",
  "hubspot-prosemirror-plugins": "static-1.18219",
  "prosemirror": "static-1.13",
  "react-colorpicker": "static-2.10206",
  "share-with-third-party-component-lib": "static-1.8701",
  "campaign-roi-lib": "static-1.9103",
  "purchase-motions-api": "static-1.5897",
  "trials-service-types": "static-1.3902",
  "bend-plugin-pulse": "static-1.74",
  "directed-graph": "static-1.933",
  "event-emitter": "static-1.946",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1955",
  "growth-onboarding-next-action-components": "static-1.1934",
  "user-context-client": "static-1.4610",
  "idb-keyval": "static-1.44",
  "magpie-lib": "static-1.5551",
  "magpie-types": "static-1.5011",
  "nest": "static-1.223",
  "reactive-lib": "static-1.722",
  "simple-logging-lib": "static-1.3047",
  "unified-auth-core-lib": "static-1.771",
  "getting-started-shared-tasks-store": "static-1.17586",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13528",
  "integrations-tracking-lib": "static-1.5600",
  "native-integrations-shared-strings": "static-1.7781",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10365",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.489",
  "calling-error-reporting": "static-1.31308",
  "shared-worker-versioning": "static-1.11034",
  "calling-usage-tracker": "static-1.6539",
  "voice-sms-access-library": "static-1.964",
  "customer-data-tracking": "static-1.6886",
  "commerce-permissions": "static-1.767",
  "products-iframe-lib": "static-1.7921",
  "products-ui-components-shared-msw-handlers": "static-1.10336",
  "location-customization-utils-lib": "static-1.9246",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4153",
  "video-components-external": "static-1.11253",
  "video-data-lib": "static-1.34911",
  "data-agent-kit": "static-1.189",
  "feedback-loader": "static-1.29294",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10037",
  "fsm": "static-1.3729",
  "policy-lib": "static-1.6778",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10100",
  "navigation-messaging": "static-1.7355",
  "FileManagerLib": "static-1.39261",
  "NamespacedHubStyle": "static-2.9056",
  "FileManagerCore": "static-1.39120",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12447",
  "layout-dnd-utils": "static-1.11422",
  "react-codemirror": "static-1.10625",
  "ui-addon-emoji-picker": "static-1.9887",
  "ui-brand-identity-lib": "static-1.15267",
  "ui-addon-video-player": "static-1.8701",
  "ui-coaching-tips": "static-1.28545",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23523",
  "EmailSignatureEditor": "static-1.24364",
  "breeze-engine-lib": "static-1.626",
  "InboxConnectUtils": "static-4.14801",
  "meetings-connect-utils-lib": "static-1.7604",
  "universal-page-editor-lib": "static-1.3012",
  "google-sheets-integration-lib": "static-1.226",
  "microsoft-drive-integration-lib": "static-1.345",
  "calling-orchestration-schema": "static-1.35741",
  "sales-views-client-types": "static-1.4257",
  "crm-record-cards-service-types": "static-1.3594",
  "content-media-composition-data-lib": "static-1.12253",
  "content-media-compositions": "static-2.16260",
  "media-bridge-lib": "static-1.18925",
  "trellis-story-utils": "static-1.4515",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5913",
  "FileManagerImages": "static-1.36772",
  "video-components": "static-1.13256",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4535",
  "video-embed": "static-1.35745",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68429",
  "layout-data-lib": "static-1.9747",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6580",
  "commerce-tours-lib": "static-1.6092",
  "growth-onboarding-reliability": "static-1.5080",
  "sales-checkout-service-client": "static-1.3639",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21676",
  "sales-email-signature-service-client": "static-1.3841",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22094",
  "outpost": "static-1.4180",
  "advanced-menus-core": "static-1.15125",
  "advanced-menus-lib": "static-1.12067",
  "ui-memberships-settings-lib": "static-1.34036",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15124",
  "simple-menus-lib": "static-1.16641"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34501",
  "atom": "/atom/static-1.5070",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2496",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.792",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39755",
  "customer-data-objects": "/customer-data-objects/static-1.7668",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8088",
  "documents-lib": "/documents-lib/static-1.34506",
  "emoji-mart": "/emoji-mart/static-3.4",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85836",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4716",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2131",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5592",
  "hs-test-utils": "/hs-test-utils/static-1.8012",
  "hub-http": "/hub-http/static-1.6221",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11471",
  "I18n": "/I18n/static-7.1626",
  "jasmine-immutable": "/jasmine-immutable/static-1.3020",
  "jasmine-runner": "/jasmine-runner/static-1.6464",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7155",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5399",
  "quartz": "/quartz/static-1.7031",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16671",
  "react-utils": "/react-utils/static-2.5341",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8170",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8093",
  "reporting-data": "/reporting-data/static-1.67528",
  "reporting-reports": "/reporting-reports/static-1.67206",
  "reporting-snowflake": "/reporting-snowflake/static-1.56146",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9461",
  "reporting-visualizations": "/reporting-visualizations/static-1.59604",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8941",
  "sanitize": "/sanitize/static-1.4475",
  "sanitize-text": "/sanitize-text/static-1.8141",
  "self-service-api": "/self-service-api/static-1.10247",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1747",
  "signup-constants": "/signup-constants/static-1.18831",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8045",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4760",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4762",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10990",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11027",
  "ui-images": "/ui-images/static-2.1154",
  "usage-tracker": "/usage-tracker/static-1.7343",
  "usage-tracker-container": "/usage-tracker-container/static-1.7333",
  "usage-tracker-core": "/usage-tracker-core/static-1.7193",
  "viral-links-lib": "/viral-links-lib/static-1.7059",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9668",
  "flux-actions": "/flux-actions/static-1.337",
  "foundations-components": "/foundations-components/static-1.7931",
  "HubStyle": "/HubStyle/static-2.11778",
  "icons": "/icons/static-2.646",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "quartz-config": "/quartz-config/static-1.809",
  "quartz-core": "/quartz-core/static-1.6250",
  "quick-fetch": "/quick-fetch/static-1.3914",
  "raven": "/raven/static-3.5907",
  "react-select-plus": "/react-select-plus/static-1.105",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-ui-components": "/reporting-ui-components/static-2.64799",
  "rpc-client-utils": "/rpc-client-utils/static-1.4650",
  "transmute": "/transmute/static-2.85",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11149",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17988",
  "UIComponents": "/UIComponents/static-3.8417",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3397",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3308",
  "quartz-webpack": "/quartz-webpack/static-1.3255",
  "foundations-assets": "/foundations-assets/static-1.4864",
  "foundations-theming": "/foundations-theming/static-1.4415",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9954",
  "hubspotter-http": "/hubspotter-http/static-1.4649",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.218",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7245",
  "crm-message-bus": "/crm-message-bus/static-1.42978",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22190",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13025",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13162",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9825",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4002",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6788",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6883",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3582",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3843",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.979",
  "onboarding-tours": "/onboarding-tours/static-1.16595",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13671",
  "ui-addon-teams": "/ui-addon-teams/static-1.21547",
  "quartz-auth": "/quartz-auth/static-1.706",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9052",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5029",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8972",
  "ContentUtils": "/ContentUtils/static-1.68354",
  "customer-data-properties": "/customer-data-properties/static-1.51536",
  "forms-ai-lib": "/forms-ai-lib/static-1.4317",
  "forms-utils-lib": "/forms-utils-lib/static-1.12579",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5414",
  "react-dnd-compat": "/react-dnd-compat/static-1.4614",
  "react-tinymce": "/react-tinymce/static-1.55233",
  "tinymce-config": "/tinymce-config/static-2.54359",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10347",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3400",
  "HeadJS": "/HeadJS/static-2.761",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3123",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.78",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4326",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.696",
  "web-vitals": "/web-vitals/static-1.5",
  "batch-promise": "/batch-promise/static-1.1539",
  "external-options-client-types": "/external-options-client-types/static-1.4155",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.706",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7927",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3696",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25368",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4877",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.956",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "quartz-routing": "/quartz-routing/static-1.461",
  "hs-story-utils": "/hs-story-utils/static-1.9424",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.225",
  "timezone-utils": "/timezone-utils/static-2.5242",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4200",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.24",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1932",
  "ui-fonts": "/ui-fonts/static-1.733",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.835",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.535",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.706",
  "quartz-tracking": "/quartz-tracking/static-1.410",
  "reporting-action-components": "/reporting-action-components/static-1.41298",
  "reporting-plugins": "/reporting-plugins/static-1.10321",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.60",
  "chirp-fetch": "/chirp-fetch/static-1.1886",
  "purchase-motions-components": "/purchase-motions-components/static-1.5894",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4077",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2898",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.148",
  "pulse": "/pulse/static-1.571",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.885",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3794",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4135",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.2",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3688",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18468",
  "growth-data-modal": "/growth-data-modal/static-1.5427",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3065",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1906",
  "navigation-components": "/navigation-components/static-1.18028",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4809",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.661",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10162",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7543",
  "ui-universal-auth": "/ui-universal-auth/static-1.8975",
  "user-context": "/user-context/static-1.5102",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9952",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21282",
  "copilot-toolkit": "/copilot-toolkit/static-1.11128",
  "cms-field-types": "/cms-field-types/static-1.4809",
  "content-icons-ui": "/content-icons-ui/static-1.2227",
  "integrations-lib": "/integrations-lib/static-1.16113",
  "calling-global-api": "/calling-global-api/static-1.64500",
  "calling-internal-common": "/calling-internal-common/static-1.31301",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65882",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58176",
  "commerce-products-lib": "/commerce-products-lib/static-1.9541",
  "crm-links": "/crm-links/static-1.6290",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9281",
  "file-manager-components": "/file-manager-components/static-1.23621",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4220",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.629",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48732",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3962",
  "property-value-citations": "/property-value-citations/static-1.2150",
  "smart-property-lib": "/smart-property-lib/static-1.6987",
  "tiered-pricing": "/tiered-pricing/static-1.1212",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9056",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19832",
  "tinymce-themes": "/tinymce-themes/static-1.56329",
  "data-token-picker": "/data-token-picker/static-1.16408",
  "hub-http-contrib": "/hub-http-contrib/static-1.3041",
  "interframe": "/interframe/static-3.4758",
  "tinymce-data": "/tinymce-data/static-1.40444",
  "tinymce-plugins": "/tinymce-plugins/static-1.57473",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5210",
  "onboarding-scopes": "/onboarding-scopes/static-1.6460",
  "ui-addon-opt": "/ui-addon-opt/static-4.8365",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4648",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.336",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.171",
  "content-assistance-lib": "/content-assistance-lib/static-1.7750",
  "dashboard-lib": "/dashboard-lib/static-1.81522",
  "ExportDialog": "/ExportDialog/static-6.10388",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18227",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18219",
  "prosemirror": "/prosemirror/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.10206",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8701",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9103",
  "purchase-motions-api": "/purchase-motions-api/static-1.5897",
  "trials-service-types": "/trials-service-types/static-1.3902",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.74",
  "directed-graph": "/directed-graph/static-1.933",
  "event-emitter": "/event-emitter/static-1.946",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1955",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1934",
  "user-context-client": "/user-context-client/static-1.4610",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-lib": "/magpie-lib/static-1.5551",
  "magpie-types": "/magpie-types/static-1.5011",
  "nest": "/nest/static-1.223",
  "reactive-lib": "/reactive-lib/static-1.722",
  "simple-logging-lib": "/simple-logging-lib/static-1.3047",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.771",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17586",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13528",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5600",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7781",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10365",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.489",
  "calling-error-reporting": "/calling-error-reporting/static-1.31308",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11034",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6539",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.964",
  "customer-data-tracking": "/customer-data-tracking/static-1.6886",
  "commerce-permissions": "/commerce-permissions/static-1.767",
  "products-iframe-lib": "/products-iframe-lib/static-1.7921",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10336",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9246",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4153",
  "video-components-external": "/video-components-external/static-1.11253",
  "video-data-lib": "/video-data-lib/static-1.34911",
  "data-agent-kit": "/data-agent-kit/static-1.189",
  "feedback-loader": "/feedback-loader/static-1.29294",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10037",
  "fsm": "/fsm/static-1.3729",
  "policy-lib": "/policy-lib/static-1.6778",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10100",
  "navigation-messaging": "/navigation-messaging/static-1.7355",
  "FileManagerLib": "/FileManagerLib/static-1.39261",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9056",
  "FileManagerCore": "/FileManagerCore/static-1.39120",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12447",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11422",
  "react-codemirror": "/react-codemirror/static-1.10625",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9887",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15267",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8701",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28545",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23523",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24364",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.626",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14801",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7604",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3012",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.226",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.345",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35741",
  "sales-views-client-types": "/sales-views-client-types/static-1.4257",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3594",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12253",
  "content-media-compositions": "/content-media-compositions/static-2.16260",
  "media-bridge-lib": "/media-bridge-lib/static-1.18925",
  "trellis-story-utils": "/trellis-story-utils/static-1.4515",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5913",
  "FileManagerImages": "/FileManagerImages/static-1.36772",
  "video-components": "/video-components/static-1.13256",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4535",
  "video-embed": "/video-embed/static-1.35745",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68429",
  "layout-data-lib": "/layout-data-lib/static-1.9747",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6580",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6092",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5080",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3639",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21676",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3841",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22094",
  "outpost": "/outpost/static-1.4180",
  "advanced-menus-core": "/advanced-menus-core/static-1.15125",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12067",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34036",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15124",
  "simple-menus-lib": "/simple-menus-lib/static-1.16641"
}
};
